/*
 * @Descripttion: * @Author: Yi Yunwan
 * @Date: 2020-09-04 17:14:37
 * @LastEditors: yaozuo
 * @LastEditTime: 2025-12-17 12:16:15
 */
import CryptoJS from 'crypto-js'
//export const javaBaseURL = 'http://japidev.wlwyl.com/'

//export const baseURL = 'http://papinewdev.wlwyl.com/'
// export const oldBaseURL = 'http://www.taktak.tv'
const AES_SECRET_KEY = CryptoJS.enc.Utf8.parse('gtD@s6Fh7pNU0WWP')
const AES_SECRET_IV = CryptoJS.enc.Utf8.parse('abcdefghijklmnop')
const remoteBaseURL =
  window.globalOyunConfig.baseURL || process.env.VUE_APP_JAVA_BASEURL
export const baseURL = process.env.VUE_APP_BASE_URL
export const javaBaseURL = CryptoJS.AES.decrypt(remoteBaseURL, AES_SECRET_KEY, {
  iv: AES_SECRET_IV,
  mode: CryptoJS.mode.CBC,
  padding: CryptoJS.pad.Pkcs7
}).toString(CryptoJS.enc.Utf8)
//备用接口地址
export const SecondBaseURL = process.env.VUE_APP_SECOND_BASE_API
//备用接口地址2
export const ThirdBaseURL = process.env.VUE_APP_THIRD_BASE_API
//export const oldBaseURL = window.globalKigoConfig.oldBaseURL
export const oldBaseURL = 'window.globalKigoConfig.oldBaseURL'

export const devToken = ''
export const webBaseURL =
  process.env.NODE_ENV === 'production'
    ? location.origin
    : 'https://webtest.wlwyl.com/'

export const reportConfig = {
  appKey: 'a8cec57d1cd5d0f2',
  baseURL: 'window.globalKigoConfig.reportBaseURL',
  debug: window.TAKTAK_DEBUG
}

export const IMConfig = {
  sdkAppId: 'window.globalKigoConfig.IMSdkAppId',
  Key: 'window.globalKigoConfig.IMKey',
  level: 4
}

export const SECRET_KEY = 'y3j1ju48uazcd51b9h56sftrkbebsuqt'

export const WX_APPID = 'window.globalKigoConfig.WX_APPID'
export const ENCRYPT_KEY = 'RXeTAxMrqcsOrblI'
export const ENCRYPT_IV = 'qazwsxedcrfvplmg'
/**
 *  app版本号
 */
export const APP_VERSION = '9.0.0'

export const H5_APP_VERSION = '5.0.0'

export const apiMock =
  process.env.NODE_ENV !== 'production' && location.href.includes('mock=true')
export const mockBaseURL = process.env.VUE_APP_MOCK_BASE_API
export const PUBLIC_KEY =
  'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA08Tn+xMe896+87zfGbdac40z221Ndl9G1U3tVyqfbeIe1lhW513aBIW6qkVvsClil+UHK94gm8QYJXt0yyCn1TQW86GnsNihAmv984dGiIxFeluWovjpSNhGmUE98ZjNpqF2WK2ph7gOdDYPfPigZaLFL2C1fpzyefkY/BQE7NVsKYkSItrMoWz/je23ha+sUPO+4WAiuYDH/xp0gMDQHUMyrKTzjalQgjd6iQnWNl/85zucZSJOKI5ACDPsExKIrhgq9REjbC1OhFgX9dA+KTg8jC5xSQFeybsBkCvi+krrd+SQNSN+Y8B7b8H4MlgHf5GCl7pbfQygvK8mA3K8QwIDAQAB'
